import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { useWatch } from 'react-hook-form';
import { styled } from '@cad-arc';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { FrCreateOrEditEventFormLeftContainer } from './fr-create-or-edit-event-form-left-container';
import { FR_FOOTER_HEIGHT, FR_HEADER_HEIGHT } from '../fr-page-layout/constants';
import { FrPageBody } from '../fr-page-layout/fr-page-body';
import { EventPanelFormPersonsFields } from '../event-panel/event-panel-form/involved-person-vehicle-fields/persons/event-panel-form-persons-fields';
import { EventPanelFormVehiclesFields } from '../event-panel/event-panel-form/involved-person-vehicle-fields/vehicles/event-panel-form-vehicles-fields';
import { vehiclesBaseKeys, personsBaseKeys } from './constants';
import { FrCreateOrEditEventFormPersonsAndVehiclesWrapper } from './fr-create-or-edit-event-form-persons-and-vehicles-wrapper';
import { EntitiesType } from './types';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { usePrefillFieldsBasedOnCallForServices } from './hooks';

const StyledDiv = styled('div')`
    display: flex;
    justify-content: flex-start;
    gap: 5px;
    height: calc(100vh - ${FR_HEADER_HEIGHT + FR_FOOTER_HEIGHT}px);
    width: 100%;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

export function FrCreateOrEditEventFormBody({
    userManuallyAddedVehicleField,
    userManuallyAddedPersonField,
}: {
    userManuallyAddedVehicleField: boolean;
    userManuallyAddedPersonField: boolean;
}) {
    const { form, isSubmitting } = useIntegratedForm<EventPanelFormType>();
    const allVehiclesList = useWatch({ control: form.control, name: vehiclesBaseKeys })?.flat();
    const allPersonsList = useWatch({ control: form.control, name: personsBaseKeys })?.flat();
    const { eventPanelConfiguration: eventConfiguration, eventPanelOptions } = useBootstrapState();
    const eventOptions = eventPanelOptions ?? ({} as EventPanelOptions);

    usePrefillFieldsBasedOnCallForServices();

    return (
        <FrPageBody>
            <StyledDiv>
                <FrCreateOrEditEventFormLeftContainer />
                <FrCreateOrEditEventFormPersonsAndVehiclesWrapper
                    entitiesType={EntitiesType.VEHICLES}
                    noEntities={!allVehiclesList?.length}
                >
                    <EventPanelFormVehiclesFields
                        form={form}
                        eventPanelOptions={eventOptions}
                        baseKey="vehicles"
                        displayAsCards
                        isReadOnly={isSubmitting}
                        userManuallyAddedVehicleField={userManuallyAddedVehicleField}
                    />
                    <EventPanelFormVehiclesFields
                        form={form}
                        eventPanelOptions={eventOptions}
                        asTowVehicle
                        baseKey="towVehicles"
                        displayAsCards
                        isReadOnly={isSubmitting}
                        userManuallyAddedVehicleField={userManuallyAddedVehicleField}
                    />
                    <EventPanelFormVehiclesFields
                        form={form}
                        eventPanelOptions={eventOptions}
                        baseKey="mergedVehicles"
                        displayAsCards
                        isReadOnly
                        userManuallyAddedVehicleField={userManuallyAddedVehicleField}
                    />
                    <EventPanelFormVehiclesFields
                        form={form}
                        eventPanelOptions={eventOptions}
                        asTowVehicle
                        baseKey="mergedTowVehicles"
                        displayAsCards
                        isReadOnly
                        userManuallyAddedVehicleField={userManuallyAddedVehicleField}
                    />
                </FrCreateOrEditEventFormPersonsAndVehiclesWrapper>
                <FrCreateOrEditEventFormPersonsAndVehiclesWrapper
                    entitiesType={EntitiesType.PERSONS}
                    noEntities={!allPersonsList?.length}
                >
                    <EventPanelFormPersonsFields
                        form={form}
                        baseKey="reportingParties"
                        eventPanelOptions={eventOptions}
                        eventPanelConfig={eventConfiguration}
                        displayAsCards
                        isReadOnly={isSubmitting}
                        userManuallyAddedPersonField={userManuallyAddedPersonField}
                    />
                    <EventPanelFormPersonsFields
                        form={form}
                        baseKey="involvedPersons"
                        eventPanelOptions={eventOptions}
                        eventPanelConfig={eventConfiguration}
                        displayAsCards
                        isReadOnly={isSubmitting}
                        userManuallyAddedPersonField={userManuallyAddedPersonField}
                    />
                    <EventPanelFormPersonsFields
                        form={form}
                        baseKey="mergedInvolvedPersons"
                        eventPanelOptions={eventOptions}
                        eventPanelConfig={eventConfiguration}
                        displayAsCards
                        isReadOnly
                        userManuallyAddedPersonField={userManuallyAddedPersonField}
                    />
                    <EventPanelFormPersonsFields
                        form={form}
                        baseKey="mergedReportingParties"
                        eventPanelOptions={eventOptions}
                        eventPanelConfig={eventConfiguration}
                        displayAsCards
                        isReadOnly
                        userManuallyAddedPersonField={userManuallyAddedPersonField}
                    />
                </FrCreateOrEditEventFormPersonsAndVehiclesWrapper>
            </StyledDiv>
        </FrPageBody>
    );
}
